var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraLowlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_966_1526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#71757A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_966_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0415 5.54199V3.95866H13.4582V2.37533H15.0415V0.791992H16.6248V2.37533H18.2082V3.95866H16.6248V5.54199H15.0415ZM8.70817 13.8545C9.69775 13.8545 10.5389 13.5081 11.2316 12.8154C11.9243 12.1227 12.2707 11.2816 12.2707 10.292C12.2707 9.30241 11.9243 8.46126 11.2316 7.76855C10.5389 7.07585 9.69775 6.72949 8.70817 6.72949C7.71859 6.72949 6.87744 7.07585 6.18473 7.76855C5.49202 8.46126 5.14567 9.30241 5.14567 10.292C5.14567 11.2816 5.49202 12.1227 6.18473 12.8154C6.87744 13.5081 7.71859 13.8545 8.70817 13.8545ZM8.70817 12.2712C8.154 12.2712 7.6856 12.0798 7.30296 11.6972C6.92032 11.3146 6.729 10.8462 6.729 10.292C6.729 9.73783 6.92032 9.26942 7.30296 8.88678C7.6856 8.50414 8.154 8.31283 8.70817 8.31283C9.26234 8.31283 9.73074 8.50414 10.1134 8.88678C10.496 9.26942 10.6873 9.73783 10.6873 10.292C10.6873 10.8462 10.496 11.3146 10.1134 11.6972C9.73074 12.0798 9.26234 12.2712 8.70817 12.2712ZM2.37484 16.6253C1.93942 16.6253 1.56668 16.4703 1.25661 16.1602C0.946539 15.8502 0.791504 15.4774 0.791504 15.042V5.54199C0.791504 5.10658 0.946539 4.73383 1.25661 4.42376C1.56668 4.11369 1.93942 3.95866 2.37484 3.95866H4.86859L6.33317 2.37533H11.8748V5.54199H13.4582V7.12533H16.6248V15.042C16.6248 15.4774 16.4698 15.8502 16.1597 16.1602C15.8497 16.4703 15.4769 16.6253 15.0415 16.6253H2.37484Z",
    fill: "#71757A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraLowlight);
export default __webpack_public_path__ + "static/media/icon-camera-lowlight.eb35b77407dc9e84f0a2a03bf41e0eb6.svg";
export { ForwardRef as ReactComponent };